import { gql } from 'urql';

const fetchExternalAccountsForTransferSource = gql`
  query FetchExternalAccountsForTransferSource {
    myAccounts {
      id
      forTransferSource {
        external {
          account {
            id
            type
            status
            institution {
              name
            }
            iconUrl
            product
            accountNumber
            accountNumberLast4
          }
        }
      }
    }
  }
`;

export default fetchExternalAccountsForTransferSource;
